import { useDispatch, useSelector } from 'react-redux'
import PageTopTitle from '../../components/shared/PageTopTitle'
import styled from 'styled-components'
import Button from '../../components/shared/Button'


import { showModal } from '../../features/modal/modalSlice'
import { useEffect, useState } from 'react'
import InputNumberNew from '../../components/shared/input/new/InputNumberNew'
import ProfilimSuruculerContainer from '../../components/profilimContainer/ProfilimSürücüler'
import Btn from '../../components/shared/button/Btn'
import { profilSurucuGet } from '../../features/companyProfile/companyProfileSlice'
import InputText from '../../components/shared/input/new/InputText'

const Container = styled.div`
width: 100%;

.wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

    .content{
        gap: 60px;
        margin: 0 30px;
        margin-top: 20px;

        .btn-group{
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 20px;
        }

        .filter-container{
          width: 100%;
          height: auto;
          /* border: 1px solid;
          border-color: ${({theme}) => theme.mainBorderColor}; */
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 20px 0;

          .filter-input-grp{
            margin: 0 2px;
            display: flex;
            gap: 20px;
          }

        }
        .titles{
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          text-align: center;
          font-weight: var(--font-weight-lg);
          font-size: var(--font-size-md);
          gap: 15px;
          padding: 15px 10px;
        }
    }
}
`

const Suruculerim = () => {

    const dispatch = useDispatch()
    const {surucuList} = useSelector((state) => state.companyProfile)
    const [phoneNumber, setPhoneNumber] = useState("")
    const [adSoyad, setAdSoyad] = useState("")
    const [isMoreActive, setIsMoreActive] = useState(null)

    const toggleMore = (item) => {
      if (isMoreActive === item) {
        setIsMoreActive(null);
      } else {
        setIsMoreActive(item);
      }
    };

    useEffect(() => {
      dispatch(profilSurucuGet({PhoneNumber: phoneNumber, AdSoyadUnvan: adSoyad}))
    }, [phoneNumber, adSoyad])

    const titles = ["Adı Soyadı", "Telefonu", "Adres"]
  return (
    <Container onClick={() => toggleMore(null)}>
    <div className="wrapper">
      <PageTopTitle title={"Sürücülerim"} position='sticky'/>
      <div className="content">
   
        <div className="filter-container">
          <div className="filter-input-grp">
            <InputNumberNew data={phoneNumber} setData={(e) => setPhoneNumber(e.target.value)} inputWidth={"220px"} name={"phoneNumber"} labelText={"Telefon Numarası"}/>
            <InputText data={adSoyad} setData={(e) => setAdSoyad(e.target.value)} inputWidth={"220px"} name={"adSoyad"} labelText={"Ad Soyad"}/>
            <Btn bgColor={"transparent"} color={"#E85446"} padding='0 10px' width='160px' >Temizle</Btn>
          </div>
          <Btn bgColor={"transparent"} color={"#E85446"} handleClick={()=> dispatch(showModal("profilSearchSurucu"))} padding='0 10px' width='160px' >Sürücü Ekle</Btn>
        </div>

        <div className="titles">
          {titles.map((item) => {
            return(
              <p>{item}</p>
            )
          })}
        </div>

        {surucuList?.map((item) => (
          <ProfilimSuruculerContainer isMoreActive={isMoreActive} toggleMore={toggleMore} data={item} />
        ))}
        {/* <Table titles={titles} data={data} type={"profilim-suruculerim"} eventQuantity={0}/> */}
    
      </div>
    </div>
  </Container>
  )
}

export default Suruculerim